import React from "react";

import {
  Outlet
} from "react-router-dom";

const RedefinePasswordBlank = (props) => {

  return (
    <Outlet/>
  );
}

export default RedefinePasswordBlank;